import {combineReducers} from 'redux';
import common from './common';
import toaster from './toaster';
import peopleInformation from './peopleInformation';
import learnerTasks from './learnerTasks';
import portalLogin from './portalLogin';
import learnerJWToken from './learnerJWToken';
import newsFeedAPI from './newsFeedAPI';
import tmsCourses from './tmsCourses';
import announcements from './announcements';
import jwkPublicKey from './jwkPublicKey';
import {DESTROY_SESSION} from './../constants';
import renewalInformation from './renewalInformation';
import currentCourseDetails from './currentCourseDetails';
import tmsAssignments from './tmsAssignments';
import tmsLearnerSessions from './tmsLearnerSessions';
import citiesList from './citiesList';
import countriesList from './countriesList'
import customFields from './customFields'
import sendOTP from './sendOTP'
import statesList from './statesList'
import updateTimezone from './updateTimezone';
import updatePeopleInformation from './updatePeopleInformation';
import skillsProgress from './skillsProgress';
import reachProgress from './reachProgress';
import sprintLevelProgress from './sprintLevelProgress';
import testProgress from './testProgress';
import createSessionService from './createSessionService';
import getTMSLearnerAvailablity from './getTMSLearnerAvailablity';
import getTMSCalendarEvents from './getTMSCalendarEvents';
import getLearnerFeedback from './getLearnerFeedback';
import learnerFeedback from './learnerFeedback';
import activityReport from './activityReport';
import putCustomFields from './putCustomFields';
import skillOutcomeSummary from './skillOutcomeSummary';
import currentSoloCourseDetails from './currentSoloCourseDetails';
import soloProgressDetails from './SoloProgressDetails';
import getLearnerDetails from './getLearnerDetails';
import getTWTSessions from './getTWTSessions';
import getTWTToken from './getTWTToken';
import getOtherTasks from './getOtherTasks';

const appReducer = combineReducers({
    common,
    toaster,
    peopleInformation,
    learnerTasks,
    portalLogin,
    learnerJWToken,
    newsFeedAPI,
    tmsCourses,
    announcements,
    jwkPublicKey,
    renewalInformation,
    currentCourseDetails,
    tmsAssignments,
    tmsLearnerSessions,
    citiesList,
    countriesList,
    customFields,
    sendOTP,
    statesList,
    updateTimezone,
    updatePeopleInformation,
    skillsProgress,
    reachProgress,
    sprintLevelProgress,
    testProgress,
    learnerFeedback,
    createSessionService,
    getTMSLearnerAvailablity,
    getTMSCalendarEvents,
    getLearnerFeedback,
    activityReport,
    putCustomFields,
    skillOutcomeSummary,
    currentSoloCourseDetails,
    soloProgressDetails,
    getLearnerDetails,
    getTWTSessions,
    getTWTToken,
    getOtherTasks
})

const rootReducer = (state: any, action: any) => {   
    // Clear all data in redux store to initial.
    if(action.type === DESTROY_SESSION)
       state = undefined;
    
    return appReducer(state, action);
 };

export default rootReducer;
